import React from 'react'

export default function FAIcon({ name, type = 'fa', className, ...props }) {
  return <i className={`${type} fa-${name.toLowerCase()} ${className}`} {...props}></i>
}
